import React, { FC } from "react";
// libs
import Calendar, { CalendarProps } from "react-calendar";
import "react-calendar/dist/Calendar.css";
// theme
import DatePickerContainer from "./DatePicker.styles";

type Props = CalendarProps & {
  choosedDate: (data: Date) => void;
  handleOpenCalendar: () => void;
};

const DatePicker: FC<Props> = ({
  choosedDate,
  handleOpenCalendar,
  minDate,
  maxDate,
  minDetail,
  maxDetail,
  ...rest
}) => {
  const selectedDate = (data: Date) => {
    choosedDate(data);
    handleOpenCalendar();
  };

  return (
    <DatePickerContainer>
      <Calendar
        formatShortWeekday={(locale, value) =>
          ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"][value.getDay()]
        }
        next2Label={null}
        prev2Label={null}
        minDetail={minDetail || "decade"}
        maxDetail={maxDetail || "month"}
        locale="en-GB"
        showNeighboringMonth={false}
        minDate={minDate || new Date()}
        maxDate={maxDate || new Date(new Date().setDate(new Date().getDate() + 14))}
        onChange={selectedDate}
        {...rest}
      />
    </DatePickerContainer>
  );
};

export default DatePicker;
